import axios from "axios";

export const updateUserProfile = async (token, userData) => {
  const { data } = await axios.put(
    `${process.env.REACT_APP_API_BASE_URL}/users/profile`,
    userData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
  return data;
};

export const changeUserPassword = async (token, passwordData) => {
  const { data } = await axios.put(
    `${process.env.REACT_APP_API_BASE_URL}/users/password`,
    passwordData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
  return data;
};
